import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { SlideGroupContext } from '../../../../../components/SlideManager';
import { EntryPoint, FieldType, TabTypeProp, TabTypePropDefault } from '../../../../../models';
import { Div } from '../../../../../layouts';
import { TrackingUtils, withPageContext } from '../../../../../utils';

export const FragmentHeader = ({
    children,
    extraTracking,
    trackEvent,
    activeProduct,
}) => {
    const context = React.useContext(SlideGroupContext);
    const currentSlideGroup = context.getCurrent();
    const shouldShowBack = currentSlideGroup.history.length > 1;
    const onClickHeaderCross = () => {
        if (activeProduct === EntryPoint.HOTELS) {
            const action = TrackingUtils.ACTION[activeProduct.toUpperCase()];
            const label = TrackingUtils.LABEL.hotelsDestinationClose();
            trackEvent({ action, label });
        }
        currentSlideGroup.active === FieldType.DATE && extraTracking();
        context.close();
    };
    return (
        <Div
            className="odf-header-mobile odf-flex-container-row odf-flex-container-justify-between odf-space-inner-left-m odf-space-inner-right-m"
            minHeight={60}
        >
            <Div
                onClick={context.prev}
                visibility={shouldShowBack ? 'visible' : 'hidden'}
            >
                <span className='odf-icon odf-icon-2xl odf-icon-arrow-left odf-icon-bidi' />
            </Div>
            <div>
                {children}
            </div>
            <div onClick={onClickHeaderCross}>
                <span className='odf-icon odf-icon-2xl odf-icon-cross-light' />
            </div>
        </Div>
    );
};

FragmentHeader.propTypes = {
    children: PropTypes.node.isRequired,
    extraTracking: PropTypes.func,
    activeProduct: TabTypeProp,
    trackEvent: PropTypes.func.isRequired,
};

FragmentHeader.defaultProps = {
    extraTracking: ()=>{},
    activeProduct: TabTypePropDefault,
};

const mapStateToProps = ({ activeProduct }) => ({
    activeProduct: activeProduct.activeProduct,
});

const connected = connect(mapStateToProps, {})(withPageContext(FragmentHeader));
export { connected as ConnectedFragmentHeader };
